import { render, staticRenderFns } from "./AllClaims.vue?vue&type=template&id=282168a7&scoped=true&"
import script from "./AllClaims.vue?vue&type=script&lang=js&"
export * from "./AllClaims.vue?vue&type=script&lang=js&"
import style0 from "./AllClaims.vue?vue&type=style&index=0&id=282168a7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282168a7",
  null
  
)

export default component.exports